<template>
  <el-dialog title="仪表合并费项编辑" class="MeterFeeTagEditor" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" width="800px" @close="closeWindow">
    <el-descriptions class="margin-top" title="" :column="1" size="mini" border :labelStyle="{width: '100px'}">
      <el-descriptions-item label="合并费项名称">
        <el-input size="mini" placeholder="合并费项名称" v-model="from_data.name" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="from_data.meter_type" filterable placeholder="仪表类型" class="kuan">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
<!--      <el-descriptions-item label="项目费项">-->
<!--        <el-input size="mini" placeholder="合并费项名称" v-model="from_data.chang_id" clearable></el-input>-->
<!--      </el-descriptions-item>-->
      <el-descriptions-item label="仪表">
        <el-select style="width: 100%;" v-model="from_data.meter_ids" multiple collapse-tags clearable filterable placeholder="请选择">
          <el-option
            v-for="item in meter_list"
            :key="item.id"
            :label="item.meter_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-switch
          v-model="from_data.status"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="0"
        >
        </el-switch>
      </el-descriptions-item>
    </el-descriptions>
    <div class="dialog-footer">
      <el-button size="mini" @click="dialogVisible=false">取消</el-button>
      <el-button size="mini" type="primary" @click="submitForm()">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "MeterFeeTagEditor",
  data(){
    return{
      project_id:0,
      from_data:{
        name:"",
        project_id:0,
        meter_type:"",
        meter_ids:"",
        chang_id:0,
        status:1,
      },
      dialogVisible:false,
      callback:null,
      meter_list:[],
      meter_type_list:[],
    }
  },
  methods:{
    show({project_id=0,id=0},callback){
      const that=this;
      that.project_id=project_id;
      that.getMeterTypeList();
      if(id){
        that.getData(id);
      }else {
        that.initData();
      }
      that.getParentSon("",data=>that.meter_list=data)
      that.dialogVisible=true;
      that.callback=callback;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getData(id=0){
      const that = this;
      let where={};
      MeterHttp.get("MeterOrderFeeTag/getData",{
        id:id,
      },ret=>{
        if(ret.code){
          ret.data.meter_ids=ret.data.meter_ids.split(',');
          that.from_data=ret.data;
        }
      })
    },
    initData(){
      this.from_data={
        name:"",
        project_id:this.project_id,
        meter_type:"",
        meter_ids:"",
        chang_id:0,
        status:1,
      }
    },
    getParentSon(ids,callback){
      MeterHttp.get("Meter/getMeterAllKeyValue",{
        ids:ids,
        project_id:this.project_id,
      },ret=>{
        if(ret.code){
          callback(ret.data);
        }else {
          callback([])
        }
      })
    },
    submitForm(){
      const that = this;
      let from_data=ERP.reJson(that.from_data);
      from_data.meter_ids=from_data.meter_ids.join(',')
      MeterHttp.post("MeterOrderFeeTag/setData",{
        ...from_data
      },ret=>{
        if(ret.code){
          that.from_data.id=ret.data.id;
          that.$message.success(ret.msg||'保存成功')
          typeof that.callback==='function'&&that.callback();
        }else {
          that.$message.error(ret.msg||'保存失败')
        }
      })
    },
    closeWindow(){
      this.callback=undefined;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.dialog-footer{
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_fee_tag/components/MeterFeeTagEditor.vue